// The server is authoritative. The deadline also pauses an already-open screen
// immediately, before the next request or tab-focus refresh reaches the server.
export function accessDeadline(family) {
  if (!family || family.is_demo || family.access_reason === "complimentary") return null;
  const value = family.access_reason === "trial" || family.subscription_status === "trial"
    ? family.trial_ends_at : family.subscription_expires_at;
  const deadline = value ? Date.parse(value) : NaN;
  return Number.isFinite(deadline) ? deadline : null;
}

export function accessPaused(family, now = Date.now()) {
  if (!family) return false;
  if (family.access_reason === "suspended") return true;
  if (family.is_demo || family.access_reason === "demo") return false;
  const deadline = accessDeadline(family);
  return family.has_access === false || (deadline !== null && now >= deadline);
}

export function stripeRedirectUrl(value) {
  const url = new URL(value);
  if (url.protocol !== "https:" || !["checkout.stripe.com", "billing.stripe.com"].includes(url.hostname) || url.username || url.password) {
    throw new Error("The checkout link could not be verified. Please try again.");
  }
  return url.href;
}
